const ACCENT_MAP: Record<string, string> = {
  a: "[aàáâã]",
  e: "[eèéê]",
  i: "[iìí]",
  o: "[oòóôõ]",
  u: "[uùú]",
  c: "[cç]",
};

function escapeRegex(char: string): string {
  return char.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

function buildPhrasePattern(phrase: string): string {
  return phrase
    .trim()
    .toLowerCase()
    .split(/\s+/)
    .map((word) =>
      word
        .split("")
        .map((char) => ACCENT_MAP[char] ?? escapeRegex(char))
        .join("")
    )
    .join("\\s+");
}

export function buildHighlightRegex(phrases: string[]): RegExp | null {
  const valid = phrases.map((p) => p.trim()).filter(Boolean);
  if (valid.length === 0) return null;

  const sorted = [...valid].sort((a, b) => b.length - a.length);
  const pattern = sorted.map(buildPhrasePattern).join("|");


  return new RegExp(`(?<![\\p{L}\\p{N}_])(${pattern})(?![\\p{L}\\p{N}_])`, "giu");
}

export function splitByHighlights(text: string, phrases: string[]): string[] {
  if (!text) return [text];
  const regex = buildHighlightRegex(phrases);
  if (!regex) return [text];
  return text.split(regex);
}